export default __webpack_public_path__ + "static/media/tabler-icon-users-plus.dcae5158.svg";